<sc-flex [fitHeight]="true" [stretchContent]="true" [vertical]="true">
    <div class="filter no-field-space" [formGroup]="formGroup">
        <sc-flex>
            <sc-date-field
                [label]="'date from' | translate:['tmc-visit.ui.export-visit-history.date-from', translationService.language]"
                formControlName="dateFrom"></sc-date-field>
            <sc-content-spacer></sc-content-spacer>
            <sc-date-field
                [label]="'date until' | translate:['tmc-visit.ui.export-visit-history.date-until', translationService.language]"
                formControlName="dateUntil"></sc-date-field>
            <sc-content-spacer></sc-content-spacer>
            <sc-string-field
                [label]="'query' | translate:['tmc-visit.ui.export-visit-history.query', translationService.language]"
                style="width: 450px;" formControlName="query"></sc-string-field>
            <sc-content-spacer></sc-content-spacer>
            <button mat-stroked-button (click)="showDetails()">show</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button (click)="createExcel()">export</button>
        </sc-flex>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
        <sc-content-area [fitHeight]="true">
            <sc-scroll-pane>
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'createdAt'| translate:['tmc-visit.entity.visithistory.createdAt',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.createdAt | timestamp }} </td>
                    </ng-container>

                    <ng-container matColumnDef="dayOfWeek">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'dayOfWeek'| translate:['tmc-visit.entity.visithistory.dayOfWeek',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.dayOfWeek}} </td>
                    </ng-container>

                    <ng-container matColumnDef="company">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'company'| translate:['tmc-visit.entity.visithistory.company',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.company}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'name'| translate:['tmc-visit.entity.visithistory.name',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="arrivedAt">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'arrivedAt'| translate:['tmc-visit.entity.visithistory.arrivedAt',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.arrivedAt | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="allDay">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'allDay'| translate:['tmc-visit.entity.visithistory.allDay',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.allDay | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="visitedPerson">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'visitedPerson'| translate:['tmc-visit.entity.visithistory.visitedPerson',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.visitedPerson}} </td>
                    </ng-container>

                    <ng-container matColumnDef="instructionsDone">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'instructionsDone'| translate:['tmc-visit.entity.visithistory.instructionsDone',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.instructionsDone | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="instructionFinish">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'instructionFinishDate'| translate:['tmc-visit.entity.visithistory.instructionFinishDate',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.instructionFinishDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="entranceAllowedWithoutGuide">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'entranceAllowedWithoutGuide'|
                            translate:['tmc-visit.entity.visithistory.entranceAllowedWithoutGuide',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.entranceAllowedWithoutGuide | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'phone'| translate:['tmc-visit.entity.visithistory.phone',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.phone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="entranceAllowedByCar">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'entranceAllowedByCar'| translate:['tmc-visit.entity.visithistory.entranceAllowedByCar',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.entranceAllowedByCar | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="numberPlate">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'numberPlate'| translate:['tmc-visit.entity.visithistory.numberPlate',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.numberPlate}} </td>
                    </ng-container>

                    <ng-container matColumnDef="chip">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'chip'| translate:['tmc-visit.entity.visithistory.chip',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.chip | booleanYesNo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="chipNumber">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'chipNumber'| translate:['tmc-visit.entity.visithistory.chipNumber',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.chipNumber}} </td>
                    </ng-container>

                    <ng-container matColumnDef="terminalRegistration">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'terminalRegistrationDate'| translate:['tmc-visit.entity.visithistory.terminalRegistrationDate',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.terminalRegistrationDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="access">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'accessDate'| translate:['tmc-visit.entity.visithistory.accessDate',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.accessDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'leaveDate'| translate:['tmc-visit.entity.visithistory.leaveDate',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.leaveDate | timestamp}} </td>
                    </ng-container>

                    <ng-container matColumnDef="accessGuidedBy">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'accessGuidedBy'| translate:['tmc-visit.entity.visithistory.accessGuidedBy',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.accessGuidedBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leaveGuidedBy">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'leaveGuidedBy'| translate:['tmc-visit.entity.visithistory.leaveGuidedBy',
                            translationService.language]}}
                        </th>
                        <td mat-cell *matCellDef="let visitHistory"> {{visitHistory.leaveGuidedBy}} </td>
                    </ng-container>

                    <ng-container matColumnDef="filler">
                        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
                        <td mat-cell *matCellDef="let transport"> &nbsp;</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let visitor; columns: columnsToDisplay"></tr>
                </table>
            </sc-scroll-pane>
        </sc-content-area>

    </sc-flex-fitting-content>
</sc-flex>